import React, { useState, useRef } from "react";
import CustomModal from "../../../../../../components/ui/CustomModal/customModal";
import ApiService from "../../../../../../components/apiService/ApiService";
import styles from "./ReplaceNumbersModal.module.css";
import { CircularProgress, Button } from "@mui/material";
import { Close } from "@mui/icons-material";

const ReplaceNumbersModal = ({
  visible,
  onClose,
  accountId,
  handleFeedback,
}) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleCancel = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    onClose();
  };

  const handleReplace = () => {
    if (!file) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    ApiService.post(`/api/v1/dashboard/replace-numbers/${accountId}/`, formData)
      .then((res) => {
        setLoading(false);
        handleFeedback(res);
        handleCancel();
      })
      .catch((error) => {
        setLoading(false);
        handleFeedback(error.response);
      });
  };

  return (
    <CustomModal
      visible={visible}
      closeModal={handleCancel}
      bodyStyles={{ maxHeight: "75vh", padding: "0 1em" }}
      heading="Replace numbers"
      body={
        <div className={styles.body}>
          <div className={styles.uploadSection}>
            <input
              type="file"
              accept=".csv"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <button
              className={styles.uploadButton}
              onClick={() =>
                fileInputRef.current && fileInputRef.current.click()
              }
            >
              {file ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "8px",
                  }}
                >
                  {file.name}

                  <Close
                    onClick={(e) => {
                      e.stopPropagation();
                      setFile(null);
                      if (fileInputRef.current) fileInputRef.current.value = "";
                    }}
                    fontSize="small"
                  />
                </div>
              ) : (
                "Choose CSV file"
              )}
            </button>
          </div>

          <div className={styles.infoBox}>
            <span className={styles.infoIcon}>*</span>
            <div className={styles.infoText}>
              <p>
                The CSV file must contain exactly two columns:{" "}
                <strong>from_number</strong> and <strong>to_number</strong>.
              </p>
              <p>
                Replacement numbers (to_number) must already exist in the
                dashboard.
              </p>
            </div>
          </div>

          <div className={styles.separator} />
          <div className={styles.footerContainer}>
            <Button
              variant="outlined"
              color="success"
              onClick={handleCancel}
              disabled={loading}
              sx={{
                textTransform: "none",
                fontSize: 14,
                height: "36px",
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={handleReplace}
              disabled={!file || loading}
              sx={{
                bgcolor: "#34cb65",
                ":hover": {
                  bgcolor: "lightgreen",
                  color: "white",
                },
                textTransform: "none",
                fontSize: 14,
                height: "36px",
              }}
            >
              {loading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                "Replace"
              )}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default ReplaceNumbersModal;
